import { useState } from 'react';

import { classifyError } from '@components/modals/LeadCaptureDialog/utils/errorClassification';
import type { SubmitError } from '@components/modals/LeadCaptureDialog/utils/errorClassification';

type UseLeadCaptureSubmitErrorResult = {
  submitError: SubmitError | null;
  handleSubmitError: (error: Error) => void;
  clearSubmitError: () => void;
};

export const useLeadCaptureSubmitError = (): UseLeadCaptureSubmitErrorResult => {
  const [submitError, setSubmitError] = useState<SubmitError | null>(null);

  const handleSubmitError = (error: Error): void => setSubmitError(classifyError(error));
  const clearSubmitError = (): void => setSubmitError(null);

  return { submitError, handleSubmitError, clearSubmitError };
};
